import React, { useState } from 'react';
import { Mail, Phone, Lock, Eye, EyeOff, ArrowLeft, CreditCard, CheckCircle2 } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';

const UyeOl = () => {
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [consents, setConsents] = useState({
    kvkk: false,
    terms: false,
    marketing: false
  });
  const navigate = useNavigate();

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 10) {
      setPhone(value);
    }
  };

  const formatPhone = (value: string) => {
    if (!value) return '';
    const match = value.match(/^(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})$/);
    if (!match) return value;
    return match
      .slice(1)
      .filter(Boolean)
      .join(' ');
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle registration logic
  };

  return (
    <div className="min-h-screen bg-slate-50 flex">
      {/* Left Column - Form */}
      <div className="flex-1 flex flex-col">
        <div className="p-8">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors"
          >
            <ArrowLeft size={20} />
            <span>Geri Dön</span>
          </button>
        </div>

        <div className="flex-1 flex items-center justify-center p-8">
          <div className="w-full max-w-md">
            <div className="text-center mb-8">
              <div className="flex items-center justify-center gap-2 mb-6">
                <CreditCard size={32} className="text-[#F7BA45]" />
                <span className="text-2xl font-bold text-slate-800">KREDİPARK</span>
              </div>
              <h1 className="text-2xl font-bold text-slate-800 mb-2">
                Hoş Geldiniz!
              </h1>
              <p className="text-slate-600">
                Hemen üye olun, avantajlı tekliflerden yararlanın
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Phone Input */}
              <div className="space-y-2">
                <label className="block text-sm font-medium text-slate-700">
                  Telefon Numarası
                </label>
                <div className="flex gap-2">
                  <div className="w-20">
                    <div className="flex items-center h-12 px-3 border border-slate-200 rounded-lg bg-slate-50 text-slate-600">
                      +90
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="relative">
                      <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" size={20} />
                      <input
                        type="text"
                        value={formatPhone(phone)}
                        onChange={handlePhoneChange}
                        placeholder="(___) ___ __ __"
                        className="w-full h-12 pl-10 pr-4 border border-slate-200 rounded-lg focus:ring-2 focus:ring-[#F7BA45] focus:border-[#F7BA45] transition-colors"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Email Input */}
              <div className="space-y-2">
                <label className="block text-sm font-medium text-slate-700">
                  E-posta Adresi
                </label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" size={20} />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="ornek@email.com"
                    className="w-full h-12 pl-10 pr-4 border border-slate-200 rounded-lg focus:ring-2 focus:ring-[#F7BA45] focus:border-[#F7BA45] transition-colors"
                  />
                </div>
              </div>

              {/* Password Input */}
              <div className="space-y-2">
                <label className="block text-sm font-medium text-slate-700">
                  Şifre
                </label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" size={20} />
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                    className="w-full h-12 pl-10 pr-12 border border-slate-200 rounded-lg focus:ring-2 focus:ring-[#F7BA45] focus:border-[#F7BA45] transition-colors"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-slate-400 hover:text-slate-600"
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
              </div>

              {/* Consent Checkboxes */}
              <div className="space-y-4">
                <label className="flex items-start gap-3 cursor-pointer group">
                  <div className="relative flex items-start">
                    <div className="bg-white border-2 rounded-lg w-6 h-6 flex flex-shrink-0 justify-center items-center
                      focus-within:border-[#F7BA45] transition-colors">
                      <input
                        type="checkbox"
                        className="opacity-0 absolute"
                        checked={consents.kvkk}
                        onChange={e => setConsents(prev => ({ ...prev, kvkk: e.target.checked }))}
                      />
                      <CheckCircle2 
                        className={`${consents.kvkk ? 'block' : 'hidden'} h-4 w-4 text-[#F7BA45] pointer-events-none`}
                      />
                    </div>
                  </div>
                  <span className="text-sm text-slate-600 group-hover:text-slate-800 transition-colors">
                    <Link to="/kvkk-aydinlatma-metni" className="text-[#F7BA45] hover:text-[#e5ac3d] font-medium">
                      KVKK Aydınlatma Metni
                    </Link>'ni okudum ve onaylıyorum.
                  </span>
                </label>

                <label className="flex items-start gap-3 cursor-pointer group">
                  <div className="relative flex items-start">
                    <div className="bg-white border-2 rounded-lg w-6 h-6 flex flex-shrink-0 justify-center items-center
                      focus-within:border-[#F7BA45] transition-colors">
                      <input
                        type="checkbox"
                        className="opacity-0 absolute"
                        checked={consents.terms}
                        onChange={e => setConsents(prev => ({ ...prev, terms: e.target.checked }))}
                      />
                      <CheckCircle2 
                        className={`${consents.terms ? 'block' : 'hidden'} h-4 w-4 text-[#F7BA45] pointer-events-none`}
                      />
                    </div>
                  </div>
                  <span className="text-sm text-slate-600 group-hover:text-slate-800 transition-colors">
                    <Link to="/kullanici-sozlesmesi" className="text-[#F7BA45] hover:text-[#e5ac3d] font-medium">
                      Kullanıcı Sözleşmesi
                    </Link>'ni okudum ve kabul ediyorum.
                  </span>
                </label>

                <label className="flex items-start gap-3 cursor-pointer group">
                  <div className="relative flex items-start">
                    <div className="bg-white border-2 rounded-lg w-6 h-6 flex flex-shrink-0 justify-center items-center
                      focus-within:border-[#F7BA45] transition-colors">
                      <input
                        type="checkbox"
                        className="opacity-0 absolute"
                        checked={consents.marketing}
                        onChange={e => setConsents(prev => ({ ...prev, marketing: e.target.checked }))}
                      />
                      <CheckCircle2 
                        className={`${consents.marketing ? 'block' : 'hidden'} h-4 w-4 text-[#F7BA45] pointer-events-none`}
                      />
                    </div>
                  </div>
                  <span className="text-sm text-slate-600 group-hover:text-slate-800 transition-colors">
                    Kampanya ve fırsatlardan haberdar olmak istiyorum.
                  </span>
                </label>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={!consents.kvkk || !consents.terms}
                className="w-full bg-[#F7BA45] hover:bg-[#e5ac3d] disabled:bg-slate-200 disabled:cursor-not-allowed 
                  text-slate-900 disabled:text-slate-500 font-medium h-12 rounded-lg transition-all duration-300 
                  shadow-lg hover:shadow-xl disabled:shadow-none"
              >
                Üye Ol
              </button>

              {/* Login Link */}
              <p className="text-center text-sm text-slate-600">
                Zaten hesabınız var mı?{' '}
                <Link to="/uye-girisi" className="text-[#F7BA45] hover:text-[#e5ac3d] font-medium">
                  Giriş Yapın
                </Link>
              </p>
            </form>
          </div>
        </div>
      </div>

      {/* Right Column - Image */}
      <div className="hidden lg:block w-1/2 bg-cover bg-center" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1579621970795-87facc2f976d?q=80&w=2070&auto=format&fit=crop)' }}>
        <div className="h-full bg-gradient-to-br from-[#F7BA45]/90 to-amber-600/90 backdrop-blur-sm p-12 flex items-center">
          <div className="max-w-lg">
            <h2 className="text-4xl font-bold text-white mb-6">
              Türkiye'nin En Kapsamlı Kredi ve Banka Karşılaştırma Platformu
            </h2>
            <p className="text-white/90 text-lg">
              Kredipark ile en uygun kredi ve kredi kartı tekliflerini karşılaştırın, 
              size en uygun olanı seçin.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UyeOl;